import { render, staticRenderFns } from "./certificatiCellComponent.vue?vue&type=template&id=70bcb026&scoped=true&"
import script from "./certificatiCellComponent.vue?vue&type=script&lang=js&"
export * from "./certificatiCellComponent.vue?vue&type=script&lang=js&"
import style0 from "./certificatiCellComponent.vue?vue&type=style&index=0&id=70bcb026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcb026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
